import { ReactNode } from 'react'

interface NoticeProps {
  children: ReactNode
}

export const Notice = ({ children }: NoticeProps) => (
  <div
    style={{
      backgroundColor: 'var(--color-surface-neutral-soft)',
      borderRadius: 'var(--radius-medium)',
      padding: 'var(--spacing-16) var(--spacing-12)',
    }}
  >
    {children}
  </div>
)
